import React from 'react';
import styles from './BookHeader.module.css';

interface BookHeaderProps {
  author: string,
  title: string,
}

export const BookHeader: React.FC<BookHeaderProps> = ({author, title}) => (
  <header className={styles.header}>
    <h1 className={styles.name}>{author}</h1>
    <h2 className={styles.tagline}>“{title}”</h2>
    <div className={styles.accentLine}></div>
  </header>
);
